import photo1 from './project25-1.png';
import photo2 from './project25-2.png';
import photo3 from './project25-3.png';
import photo4 from './project25-4.png';
import photo5 from './project25-5.png';
import photo6 from './project25-6.png';

const project25 = {
  id: 25,
  name: 'MAVVE',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '우윤수, 이가빈, 함하경',
    },
    {
      position: 'BackEnd Developer',
      names: '김규린, 복지희, 양은서, 홍지형',
    },
    {
      position: 'UXUI Designer',
      names: '길혜민',
    },
  ],
    about:
    "“우린 떨어져 있어도, 같은 음악을 들으면 연결될 수 있어요.”\n" +
    "Mavve는 음악을 함께 듣는 순간을 제공하고 사람들을 이어주는 감성 작업 공간입니다.\n" +
    "우리만의 공간을 만들고 친구들과 실시간 플레이리스트를 공유하며, 마치 한자리에 있는 듯 깊게 몰입하는 새로운 연결을 경험해보세요.",  
    links: {
        website: 'https://mavve.vercel.app',
        github: 'https://github.com/EFUB5-RoomListener',
  },
  photos: [photo1, photo2, photo3, photo4, photo5, photo6],
};

export default project25;
